import { render, staticRenderFns } from "./AgrupamentoProjectsList.vue?vue&type=template&id=78aded88&scoped=true&"
import script from "./AgrupamentoProjectsList.vue?vue&type=script&lang=js&"
export * from "./AgrupamentoProjectsList.vue?vue&type=script&lang=js&"
import style0 from "./AgrupamentoProjectsList.vue?vue&type=style&index=0&id=78aded88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78aded88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDataTable,VIcon})
